import { systemColors } from "../system";

const surface = {
  default: systemColors["sys-neutral"][50],
  subtle: systemColors["sys-neutral"][100],
  elevated: systemColors["sys-neutral"][300],
  inverse: systemColors["sys-black"][850],
};

const functional = {
  info: systemColors["sys-lavender"][100],
  success: systemColors["sys-olive"][100],
  benefit: systemColors["sys-green"][300],
  price: systemColors["sys-pink"][600],
  reassurance: systemColors["sys-blue"][100],
  warning: systemColors["sys-marmalade"][100],
  destructive: systemColors["sys-red"][100],
  fresh: systemColors["sys-chartreuse"][600],
  scoop: systemColors["sys-green"][600],
};

const button = {
  default: {
    DEFAULT: systemColors["sys-black"][850],
    pressed: systemColors["sys-black"][500],
    focus: systemColors["sys-black"][850],
  },
  secondary: {
    DEFAULT: systemColors["sys-chartreuse"][600],
    pressed: systemColors["sys-chartreuse"][400],
    focus: systemColors["sys-chartreuse"][600],
  },
  tertiary: {
    DEFAULT: systemColors["sys-white"],
    pressed: systemColors["sys-neutral"][100],
  },
  destructive: {
    DEFAULT: systemColors["sys-white"],
  },
};

const badge = {
  default: systemColors["sys-black"][850],
  outline: systemColors["sys-white"],
  secondary: systemColors["sys-chartreuse"][600],
  price: systemColors["sys-pink"][600],
};

const tag = {
  discount: systemColors["sys-green"][100],
};

const pill = {
  default: systemColors["sys-white"],
  price: functional.price,
  benefit: functional.benefit,
  warning: functional.warning,
  destructive: functional.destructive,
};

const tooltip = {
  surface: systemColors["sys-black"][850],
  shortcut: systemColors["sys-opacity-light"][80],
};

const progress = {
  track: systemColors["sys-neutral"][300],
  indicator: systemColors["sys-black"][900],
};

const input = {
  default: systemColors["sys-black"][50],
  "focused": systemColors["sys-white"],
};

const select = {
  item: {
    focused: systemColors["sys-neutral"][600],
  },
};


const interactive = {
  default: systemColors["sys-white"],
  pressed: systemColors["sys-black"][850],
  elevated: systemColors["sys-neutral"][200],
  subtle: systemColors["sys-neutral"][100],
  opaque: systemColors["sys-opacity-light"][20],
  hover: systemColors["sys-chartreuse"][25],
  "hover-2": systemColors["sys-chartreuse"][25],
};

const alert = {
  subtle: surface.subtle,
  info: functional.info,
  reassurace: functional.reassurance,
  success: functional.success,
  destructive: functional.destructive,
  fyi: surface.elevated,
};

const callout = {
  default: systemColors["sys-white"],
  reassurance: functional.reassurance,
  subtle: surface.subtle,
  elevated: surface.elevated,
};

const checkbox = {
  check: {
    unchecked: input.default,
    checked: systemColors["sys-black"][850],
  },
};

const dialog = {
  DEFAULT: interactive.subtle,
};

const tabs = {
  list: {
    variant: {
      pill: interactive.elevated,
    },
  },
  trigger: {
    variant: {
      pill: {
        default: systemColors["sys-transparent"],
        active: interactive.pressed,
      },
    },
  },
};

const collapsable = {
  trigger: {
    variant: {
      secondary: interactive.elevated,
    },
  },
};

const dropdown = {
  separator: systemColors["sys-grey"][200],
};

const dropdownMenu = {
  separator: systemColors["sys-grey"][200],
  viewport: interactive.default,
};

const responsiveNavigation = {
  DEFAULT: systemColors["sys-white"],
  item: {
    active: systemColors["sys-chartreuse"][50],
  },
};

const headedSection = {
  header: {
    default: systemColors["sys-black"],
    simple: systemColors["sys-white"],
    content: systemColors["sys-blue"][600],
    scoop: functional.scoop,
    fresh: functional.fresh,
    elevated: surface.elevated,
  },
  content: {
    default: surface.default,
    simple: surface.default,
    content: surface.default,
    scoop: surface.default,
    fresh: surface.default,
    elevated: surface.default,
  },
};

const socialProof = {
  avatar: systemColors["sys-blue"][600],
};

const component = {
  callout,
  checkbox,
  button,
  badge,
  tag,
  pill,
  input,
  select,
  interactive,
  tooltip,
  tabs,
  alert,
  dialog,
  progress,
  collapsable,
  dropdown,
  dropdownMenu,
  "responsive-navigation": responsiveNavigation,
  "headed-section": headedSection,
  "social-proof": socialProof,
};

const state = {
  loading: systemColors["sys-grey"][50],
};

export const backgroundColor = {
  DEFAULT: systemColors["sys-neutral"][600],
  brand: systemColors["sys-chartreuse"][600],
  inverse: systemColors["sys-black"][900],
  elevated: systemColors["sys-neutral"][50],
  surface,
  functional,
  component,
  state,
};
